module.exports = __webpack_public_path__ + "img/icon-zenith-saude.2e850c8e.svg";